import type {ReactNode} from 'react'
import {addMaybeClassName} from '@freckle/educator-entities/ts/common/helpers/classnames'
import {H3} from '@freckle/educator-materials/ts/components/typography'
import {panel, panelHeading, panelBody, panelHeadingTitle} from './panel.module.scss'

type Props = {
  headingTitle: string
  headingAction?: ReactNode | null
  children: ReactNode
  /** Additional CSS Class to add to the component */
  className?: string
}

export function Panel(props: Props) {
  const {headingTitle, headingAction, children, className} = props

  return (
    <div className={addMaybeClassName(panel, className)}>
      <div className={panelHeading}>
        <H3 className={panelHeadingTitle}>{headingTitle}</H3>
        {headingAction}
      </div>
      <div className={panelBody}>{children}</div>
    </div>
  )
}
